import { render, staticRenderFns } from "./Correlativass.vue?vue&type=template&id=09b9f397&scoped=true&"
import script from "./Correlativass.vue?vue&type=script&lang=js&"
export * from "./Correlativass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b9f397",
  null
  
)

export default component.exports